import { render, staticRenderFns } from "./UploadPix.vue?vue&type=template&id=6a4cedd4&scoped=true&"
import script from "./UploadPix.vue?vue&type=script&lang=js&"
export * from "./UploadPix.vue?vue&type=script&lang=js&"
import style0 from "./UploadPix.vue?vue&type=style&index=0&id=6a4cedd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4cedd4",
  null
  
)

export default component.exports